import React, { useContext } from 'react';
// import '../styles/TiendaSeleccionada.css';

const TiendaSeleccionadaReagendamiento = ({datosReserva}) => {
  // console.log("datosss: ", datosReserva);
    return (
        <div className="row booking-resume-location mb20">
          <div className="col-2">
            <img
              src="https://cdn.shopify.com/s/files/1/0015/7610/8121/files/ico_gmo1.png?v=1724945945"
              alt=""
              className="img-fluid"
            />
          </div>
          <div className="col-10">
            <div className="basic-booking-info">
              <h6 className="monts-b basic-booking-info-store">
                {datosReserva?.data.datos_tienda?.nombre || "No seleccionada"}
              </h6>
              <p className="basic-booking-info-address">
                {datosReserva?.data.datos_tienda?.direccion || "Sin dirección"}
                <br />
                {/* {datosReserva?.data.datos_tienda?.ubicacion || "Sin ubicación"} */}
              </p>
            </div>
          </div>
          <div className="col-12 text-center">
          <a
  href={
    datosReserva?.data.datos_tienda.cfg_latitud && datosReserva?.data.datos_tienda.cfg_longitud // Verificar que ambas coordenadas existan
      ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
          `${datosReserva?.data.datos_tienda.cfg_latitud.replace(",", ".")},${datosReserva?.data.datos_tienda.cfg_longitud.replace(",", ".")}`
        )}`
      : "#"
  }
  target="_blank"
  rel="noopener noreferrer"
  onClick={(e) => {
    if (!datosReserva?.data.datos_tienda.cfg_latitud || !datosReserva?.data.datos_tienda.cfg_longitud) {
      e.preventDefault(); // Evitar que el enlace intente navegar si no hay coordenadas válidas
      console.warn("Las coordenadas no están disponibles.");
    }
  }}
> <p className="direction-button">
                    CÓMO LLEGAR
        </p>
</a>
          </div>
        </div>
   
  
    );
};






export default TiendaSeleccionadaReagendamiento;